import classnames from 'classnames';
import { observer } from 'mobx-react';

import { ImageData } from '../../../data/model';
import List from '../../../shared/components/List/List';
import Markdown from '../../../shared/components/Markdown/Markdown';
import Heading, { HeadingSize } from '../../../shared/components/Typography/Heading/Heading';
import css from './ProductModelInfo.css';

interface ProductModelInfoProps {
  description: string;
  icons: ImageData[];
  name: string;
  className?: string;
}

const ProductModelInfo = ({ className, description, icons, name }: ProductModelInfoProps) => {
  return (
    <div className={classnames(css.root, className)}>
      <Heading level={1} size={HeadingSize.ExtraLarge} className={css.name}>
        {name}
      </Heading>
      {description && <Markdown className={css.description} content={description} />}
      <List
        className={css.iconList}
        items={icons}
        itemRenderer={(item) => <img className={css.icon} src={item.url} alt={item.name} />}
      />
    </div>
  );
};

export default observer(ProductModelInfo);
